
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { useRouter } from 'next/router';
import { addApolloState, initializeApollo } from '@lib/apollo';
import { GET_STORY_BY_SHARE_KEY } from '@api/story';
import { ShareStory, StoryByShareKey } from '@customTypes/story';
import { BASE_URL } from '@common/values';

import ShareLayout from '@components/share/ShareLayout';
import StorySummary from '@components/share/story/StorySummary';

interface IStoryShare {
  shareStory: ShareStory;
}

const StoryShare = ({ shareStory }: IStoryShare) => {
  const route = useRouter();

  return (
    <ShareLayout
      head={{
        title: shareStory.title,
        description: shareStory.summary,
        ogTitle: shareStory.title,
        ogDescription: shareStory.summary,
        ogUrl: `${BASE_URL}/${route.asPath}`,
        ogImage: shareStory.imageUrl,
      }}
    >
      <StorySummary {...shareStory} />
    </ShareLayout>
  );
};

 const _getServerSideProps = async (context: {
  params: { storyUid: string };
}) => {
  const client = initializeApollo();

  try {
    const res = await client.query<StoryByShareKey>({
      query: GET_STORY_BY_SHARE_KEY,
      variables: {
        id: context.params.storyUid,
      },
    });

    const shareStory: ShareStory = {
      id: context.params.storyUid,
      title: res.data.getStoryByShareKey.name,
      author: res.data.getStoryByShareKey.authorName,
      imageUrl: res.data.getStoryByShareKey.coverImageLink
        ? res.data.getStoryByShareKey.coverImageLink
        : 'https://s3.ap-northeast-2.amazonaws.com/storyplay-prod/ImageFile/c1f7f3a5-79cb-45ff-97d8-fe534002bb4d',
      genre: res.data.getStoryByShareKey.topic,
      age: res.data.getStoryByShareKey.ageTarget,
      summary: res.data.getStoryByShareKey.desc,
      storyId: res.data.getStoryByShareKey.storyId,
    };

    return addApolloState(client, {
      props: { shareStory },
    });
  } catch (e) {
    return {
      notFound: true,
    };
  }
};

export default StoryShare;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/share/story/[storyUid]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  